import { ref } from 'vue';

export default function useAnimating() {
    const animating = ref(false);
    const timeout = ref<NodeJS.Timeout>();
    const interval = ref<NodeJS.Timeout>();

    function startAnimating(afterSeconds: number, repeatAfterSeconds: number, animationSpeed: number = 1000) {
        timeout.value = setTimeout(() => {
            interval.value = setInterval(() => {
                animating.value = true;
                setTimeout(() => {
                    animating.value = false;

                    if (repeatAfterSeconds === 0) {
                        clearInterval(interval.value);
                    }
                }, animationSpeed);
            }, (repeatAfterSeconds * 1000) + animationSpeed);
        }, afterSeconds * 1000);
    }

    return {
        animating,
        startAnimating,
    };
}
